import React, { useContext, useEffect } from 'react';
import AuthContext  from '../../context/auth/authContext';

const Bar = () => {

     // Extract information of authentication
     const authContext = useContext(AuthContext);
     const { user, authenticatedUser, logoutUser } = authContext;
 
     useEffect(() => {
         authenticatedUser();
         //eslint-disable-next-line
     }, []);

    return ( 
        <header className="app-header">
            { user ? <p className="nombre-usuario">Hello <span>{ user.name }</span></p> : null }
            <nav className="nav-principal">
                <button
                    className="btn btn-blank cerrar-sesion"
                    onClick={ () => logoutUser() }
                >
                    Logout
                </button>
            </nav>
        </header>
     );
}
 
export default Bar;